'use client';

import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';
import { HistoryLastPage } from '../../models/history';

const HistoryContext = createContext<{
  lastPage: null | HistoryLastPage;
  setLastPage: Dispatch<SetStateAction<HistoryLastPage | null>>;
}>({ lastPage: null, setLastPage: () => {} });

export function HistoryProvider({ children }: PropsWithChildren) {
  const [lastPage, setLastPage] = useState<HistoryLastPage | null>(null);

  const contextValue = useMemo(
    () => ({
      lastPage,
      setLastPage,
    }),
    [lastPage]
  );

  return (
    <HistoryContext.Provider value={contextValue}>
      {children}
    </HistoryContext.Provider>
  );
}

export function useHistory() {
  return useContext(HistoryContext);
}
